import React, { Component } from 'react';

import { Loader } from 'common';
import {
  authenticateProduct,
  getAllUserIntegrations,
} from 'controllers/integrations';

class AuthenticateProduct extends Component {
  async componentDidMount() {
    const { match, location, history } = this.props;
    const { productName } = match.params;
    const { search: queryParams } = location;
    const searchParams = new URLSearchParams(queryParams);
    const state = searchParams.get('state');
    const code = searchParams.get('code');

    const integrations = await getAllUserIntegrations();

    const product = integrations.response.find(
      ({ integrationDto }) =>
        integrationDto.product.toLowerCase() === productName.toLowerCase()
    );
    const { integrationId } = product.integrationDto;

    authenticateProduct(productName, { state, code, integrationId }, history);
  }

  render() {
    return <Loader />;
  }
}

export default AuthenticateProduct;
